import { useState } from "react";
import type { ProjectResp } from "@pix/shared";
import { AuthProvider, useAuth } from "./auth/AuthContext";
import { LoginView } from "./views/LoginView";
import { ProjectListView } from "./views/ProjectListView";
import { StudioView } from "./views/StudioView";

export function App() {
  return (
    <AuthProvider>
      <Router />
    </AuthProvider>
  );
}

function Router() {
  const { user, loading } = useAuth();
  const [project, setProject] = useState<ProjectResp | null>(null);

  if (loading) {
    return (
      <div className="loading-screen">
        <div>Pix Studio Online</div>
        <div className="loading-sub">読み込み中...</div>
      </div>
    );
  }

  if (!user) {
    return <LoginView />;
  }

  if (!project) {
    return <ProjectListView onOpen={setProject} />;
  }

  return <StudioView project={project} onLeave={() => setProject(null)} />;
}
